import { isEmpty, isString } from './common';

export const removeEmptyStrings = <T>(arr: T[]): Array<Exclude<T, string | ''>> =>
  arr.filter(item => !(isString(item) && isEmpty(item.trim()))) as Array<Exclude<T, string | ''>>;

export const skipHashTag = (str: string) => str.replace(/^#/, '');
